export const getFilterObjectIdIs = (nameParam, value) => {
    return {
        typeData:"ObjectId",
        operator:"is",
        nameProperty:nameParam,
        value:value
    }
}